import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { app, auth, googleProvider, firebaseConfig } from "./firebase-app";

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "southamerica-east1");

export { app, auth, googleProvider, firebaseConfig };
